import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix SSO icon. Exported from Figma (Bombiix 2026). */
const SSOIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <g>
      <g>
        <path
          d="M18.6097 20.0029C19.9497 20.0129 21.2397 19.5129 22.2297 18.6129C25.4997 15.7529 23.7497 10.0129 19.4397 9.47288C17.8997 0.132878 4.42973 3.67288 7.61973 12.5629"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.27938 12.9708C8.74938 12.7008 8.15938 12.5608 7.56938 12.5708C2.90938 12.9008 2.91938 19.6808 7.56938 20.0108"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8203 9.89047C18.3403 9.63047 18.9003 9.49047 19.4803 9.48047"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <path
      d="M14.4221 17.5872C12.8453 17.5914 11.5637 16.3167 11.5594 14.7399C11.5551 13.1632 12.8299 11.8815 14.4066 11.8773C15.9834 11.873 17.265 13.1478 17.2693 14.7245C17.2735 16.3012 15.9988 17.5829 14.4221 17.5872ZM14.4221 17.5872L14.4384 23.6539C14.4389 23.851 14.2796 24.0112 14.0825 24.0117L12.2982 24.0166M14.4316 21.1558L12.2904 21.1615"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default SSOIcon;
